module.exports = dibs_admin_layout;